import { useQuery } from '@tanstack/react-query';
import { useMeOptions } from '../../users';
import { useEffect } from 'react';
import { selectedProjectStore } from '../stores';

const useInitialProject = () => {
  const { data: me } = useQuery(useMeOptions);

  useEffect(() => {
    if (me) {
      selectedProjectStore.init(me);
    }
  }, [me]);
};

export default useInitialProject;
